import styled from 'styled-components'

export const MainWrap = styled.div`
  --text/button/quaternary: #666666;
  --background/button/primary: #222222;
  --background/surface/primary: #ffffff;
  --text/basic/default: #222222;
  --bordar/line/tertiary: #d8d8d8;
  --background/button/secondary: #ffffff;
  --text/button/primary: #ffffff;
  --gray/950: #222222;
  --purple/500: #6250ff;
  --wb/black: #000000;
`
export const ContentWrap = styled.div`
  margin: 30px 20px 0 20px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 48px;
`

export const IntroduceWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Gap-S12, 12px);

  align-self: stretch;
`
export const Title = styled.div`
  color: #222;

  /* Headline/H2.22.B */
  font-family: 'Noto Sans KR';
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 145.455% */
  letter-spacing: -0.88px;
`
export const SubTitle = styled.div`
  color: #505050;

  /* Body/B3.12.R */
  font-family: 'Noto Sans KR';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  letter-spacing: -0.36px;
`
export const IntroduceImageWrap = styled.img.attrs({ alt: '이미지' })`
  max-width: 320px;
  width: 100%;
  height: 260px;
  flex-shrink: 0;
  margin: 0 auto;
`
export const UlContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
`
export const UlContentLayout = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`
export const UlContentTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Gap-S12, 12px);

  flex: 1 0 0;
`
export const UlTitle = styled.div`
  color: #222;

  font-family: 'Noto Sans KR';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 144.444% */
  letter-spacing: -0.72px;
`
export const UlSubTitle = styled.div`
  color: #7a7a7a;

  /* Body/B3.12.R */
  font-family: 'Noto Sans KR';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  letter-spacing: -0.36px;
`
export const UlImage = styled.img.attrs({ alt: '이미지' })`
  width: 92px;
  height: 92px;
  flex-shrink: 0;
`
export const PriceNoticeWrap = styled.div`
  color: #222;
  /* Headline/H2.22.B */
  font-family: 'Noto Sans KR';
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.88px;

  .price {
    color: #3dc289;

    /* Headline/H2.22.B */
    font-family: 'Noto Sans KR';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 145.455% */
    letter-spacing: -0.88px;
  }

  .bracket {
    color: #222;

    /* Body/B3.12.R */
    font-family: 'Noto Sans KR';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.36px;
  }
`
const footerHeight = 90
export const FooterContentWrap = styled.div`
  display: flex;

  margin-top: 48px;
  padding: 32px 20px 48px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex-shrink: 0;
  background: #f0f2f4;
`
export const FooterContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`
export const FooterContentTitle = styled.strong`
  align-self: stretch;
  color: #7a7a7a;

  /* Body/B3.12.B */
  font-family: 'Noto Sans KR';
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 150% */
  letter-spacing: -0.36px;
`
export const FooterContentNotiWrap = styled.ul``
export const FooterContentNoti = styled.li`
  align-self: stretch;
  color: #7a7a7a;

  /* Body/B3.12.R */
  font-family: 'Noto Sans KR';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  letter-spacing: -0.36px;

  list-style-type: none;
  position: relative;
  padding-left: 15px;

  &::before {
    content: '⦁';
    position: absolute;
    left: 5px;
    font-size: 1em;
  }
`
export const FooterWrap = styled.div`
  display: flex;

  height: ${footerHeight}px;
  padding: var(--Gap-S20, 20px);

  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex-shrink: 0;
  background: #fff;
`
export const FooterButton = styled.button`
  display: flex;
  padding: var(--Gap-S12, 12px) var(--Gap-S20, 20px);

  justify-content: center;
  align-items: center;
  gap: 4p x;
  align-self: stretch;

  border-radius: var(--Corner-R12, 12px);
  border: solid 1px var(--border-button-primary, #222);
  background: var(--background-button-primary, #fff);

  color: var(--text-button-primary, #222);
  text-align: center;
  /* Body/B1.16.B */
  font-family: 'Noto Sans KR';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 162.5% */
  letter-spacing: -0.64px;

  cursor: pointer;

  -webkit-tap-highlight-color: transparent;
`
